import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99430a97"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-mms-caret",
  width: "9",
  height: "9",
  viewBox: "0 0 10 10",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3 1.5 7 5 3 8.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-mms-title" }, "Marks", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  class: "nge-mms-started",
  title: "When you first worked on this cell. A Super Quest is yours for 2 months from when you claimed it."
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_7 = {
  key: 0,
  class: "nge-mms-body"
}
const _hoisted_8 = { class: "nge-mms-how" }
const _hoisted_9 = {
  class: "nge-mms-list",
  role: "radiogroup",
  "aria-label": "Mark to place"
}
const _hoisted_10 = ["aria-checked"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 0,
  class: "nge-mms-sub"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The starting point is the nucleus, inside the soma.", -1 /* HOISTED */))
const _hoisted_15 = { class: "nge-mms-btns" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["aria-checked", "title", "onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 1,
  class: "nge-mms-sub"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The lab's sheet has a point where the axon leaves the cell. Go there, move the crosshairs if it is off, then confirm: the mark goes where the crosshairs are.", -1 /* HOISTED */))
const _hoisted_22 = { class: "nge-mms-btns" }
const _hoisted_23 = {
  key: 2,
  class: "nge-mms-sub"
}
const _hoisted_24 = { class: "nge-mms-foot" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["title"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 1,
  class: "nge-mms-progress",
  role: "status"
}
const _hoisted_29 = { class: "nge-mms-bar" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nge-mms", { 'nge-mms--open': $setup.open }])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "nge-mms-head",
      "aria-expanded": $setup.open ? 'true' : 'false',
      onClick: _cache[0] || (_cache[0] = $event => ($setup.open = !$setup.open)),
      title: $setup.open ? 'Hide the marks' : 'Mark this cell for the lab, and see what is placed'
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("span", {
        class: _normalizeClass(["nge-mms-chip", { 'nge-mms-chip--none': $setup.soma.state === 'none' }]),
        style: _normalizeStyle({ '--k': $setup.MEC_SOMA.color })
      }, [
        _hoisted_4,
        _createTextVNode("Soma " + _toDisplayString($setup.soma.state === 'none' ? 'not yet' : '✓'), 1 /* TEXT */)
      ], 6 /* CLASS, STYLE */),
      ($props.started)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.started), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.marks, (k) => {
        return (_openBlock(), _createElementBlock("span", {
          key: k.key,
          class: _normalizeClass(["nge-mms-chip", { 'nge-mms-chip--none': !$setup.counts[k.key] }]),
          style: _normalizeStyle({ '--k': k.color })
        }, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(k.label) + " " + _toDisplayString($setup.counts[k.key] ?? 0), 1 /* TEXT */)
        ], 6 /* CLASS, STYLE */))
      }), 128 /* KEYED_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_1),
    ($setup.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode("Pick a mark (or press its number), then Ctrl + click the cell to place it."),
            ($props.superQuest)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Only the AIS is required.")
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              role: "radio",
              class: _normalizeClass(["nge-mms-row", { 'nge-mms-row--on': $setup.armed === $setup.MEC_SOMA.key }]),
              "aria-checked": $setup.armed === $setup.MEC_SOMA.key ? 'true' : 'false',
              style: _normalizeStyle({ '--k': $setup.MEC_SOMA.color }),
              onClick: _cache[1] || (_cache[1] = $event => ($setup.arm($setup.MEC_SOMA.key)))
            }, [
              _hoisted_11,
              _createElementVNode("b", null, [
                _createTextVNode("Soma"),
                ($setup.keyOf[$setup.MEC_SOMA.key])
                  ? (_openBlock(), _createElementBlock("kbd", {
                      key: 0,
                      class: "nge-mms-key",
                      title: `Key ${$setup.keyOf[$setup.MEC_SOMA.key]}`
                    }, _toDisplayString($setup.keyOf[$setup.MEC_SOMA.key]), 9 /* TEXT, PROPS */, _hoisted_12))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("span", null, _toDisplayString($setup.somaLine()), 1 /* TEXT */)
            ], 14 /* CLASS, STYLE, PROPS */, _hoisted_10),
            ($setup.armed === $setup.MEC_SOMA.key)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  ($setup.hasStart)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_14,
                        _createElementVNode("span", _hoisted_15, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "nge-mms-btn",
                            onClick: $setup.lookAtStart
                          }, "Go to the starting point"),
                          _createElementVNode("button", {
                            type: "button",
                            class: "nge-mms-btn nge-mms-btn--ok",
                            title: "Put the Soma mark where the crosshairs are",
                            onClick: $setup.confirmSoma
                          }, _toDisplayString($setup.soma.state === 'none' ? 'Confirm soma here' : 'Move soma here'), 1 /* TEXT */)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "Ctrl + click a colored part of the soma."))
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.marks, (k) => {
              return (_openBlock(), _createElementBlock("button", {
                key: k.key,
                type: "button",
                role: "radio",
                class: _normalizeClass(["nge-mms-row", { 'nge-mms-row--on': $setup.armed === k.key }]),
                "aria-checked": $setup.armed === k.key ? 'true' : 'false',
                style: _normalizeStyle({ '--k': k.color }),
                title: k.hint,
                onClick: $event => ($setup.arm(k.key))
              }, [
                _hoisted_18,
                _createElementVNode("b", null, [
                  _createTextVNode(_toDisplayString(k.label), 1 /* TEXT */),
                  ($setup.keyOf[k.key])
                    ? (_openBlock(), _createElementBlock("kbd", {
                        key: 0,
                        class: "nge-mms-key",
                        title: `Key ${$setup.keyOf[k.key]}`
                      }, _toDisplayString($setup.keyOf[k.key]), 9 /* TEXT, PROPS */, _hoisted_19))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("span", null, _toDisplayString($setup.markLine(k.key, $setup.counts[k.key] ?? 0)), 1 /* TEXT */)
              ], 14 /* CLASS, STYLE, PROPS */, _hoisted_17))
            }), 128 /* KEYED_FRAGMENT */)),
            ($setup.armed === 'mec:ais' && $setup.labAis)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-mms-btn",
                      onClick: $setup.lookAtLabAis
                    }, "Go to the lab's AIS point"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-mms-btn nge-mms-btn--ok",
                      title: "Put the AIS mark where the crosshairs are",
                      onClick: $setup.confirmAis
                    }, _toDisplayString($setup.aisState() === 'none' ? 'Confirm AIS here' : 'Move AIS here'), 1 /* TEXT */)
                  ])
                ]))
              : ($setup.armed && $setup.armed !== $setup.MEC_SOMA.key)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", null, _toDisplayString($setup.hintOf($setup.armed)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            ($setup.SHOW_FIND_ENDS && !$props.superQuest)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "nge-mms-btn",
                  disabled: $setup.busy || $setup.autoLooking !== null,
                  onClick: $setup.findEdges,
                  title: "Mark Hits Edge wherever the cell reaches the end of the data, from the lab's image mask."
                }, "Find ends at the edge", 8 /* PROPS */, _hoisted_25))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              type: "button",
              class: "nge-mms-btn",
              onClick: $setup.toggleMarks,
              title: $setup.marksHidden ? 'Show the marks again' : 'Hide the marks, to see the cell. Nothing is removed.'
            }, _toDisplayString($setup.marksHidden ? 'Show marks' : 'Hide marks'), 9 /* TEXT, PROPS */, _hoisted_26),
            _createElementVNode("button", {
              type: "button",
              class: "nge-mms-btn",
              disabled: $setup.busy,
              onClick: $setup.undoLast,
              title: "Remove the newest mark. All the Hits Edge marks one search placed go together."
            }, "Undo", 8 /* PROPS */, _hoisted_27),
            ($setup.looking !== null || $setup.autoLooking !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: Math.round((($setup.looking ?? $setup.autoLooking) ?? 0) * 100) + '%' })
                    }, null, 4 /* STYLE */)
                  ]),
                  _createTextVNode(" Looking for the edge of the data, " + _toDisplayString(Math.round((($setup.looking ?? $setup.autoLooking) ?? 0) * 100)) + "% ", 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(["nge-mms-msg", { 'nge-mms-msg--bad': $setup.bad }]),
                  role: "status"
                }, _toDisplayString($setup.message || "The lab's sheet gets these counts when you complete the cell."), 3 /* TEXT, CLASS */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}